var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M9,0V20A10.06,10.06,0,0,1,9,0Zm2,0V9h9A10,10,0,0,0,11,0Zm0,11v9a10,10,0,0,0,9-9Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }